export const RESULT_FETCH_ALL_FOR_CHAPTER = 'RESULT_FETCH_ALL_FOR_CHAPTER';
export const RESULT_FETCH_ALL_FOR_CHAPTER_INIT = 'RESULT_FETCH_ALL_FOR_CHAPTER_INIT';
export const RESULT_FETCH_ALL_FOR_CHAPTER_DONE = 'RESULT_FETCH_ALL_FOR_CHAPTER_DONE';

export const RESULT_CLEAR = 'RESULT_CLEAR';
